const time = {}

time.formatDateTime = (timestamp, format = 'yyyy-MM-dd') => {
  const date = new Date(timestamp)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  let h = date.getHours()
  h = h < 10 ? ('0' + h) : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? ('0' + minute) : minute
  second = second < 10 ? ('0' + second) : second
  return format.replace('yyyy', y).replace('MM', m).replace('dd', d).replace('HH', h).replace('mm', minute).replace('ss', second)
}

time.getDayZeroDate = (timestamp) => {
  const date = new Date(timestamp)
  date.setSeconds(0)
  date.setMinutes(0)
  date.setHours(0)
  return date
}

time.getDayZeroDate = (timestamp) => {
  const date = new Date(timestamp)
  date.setSeconds(0)
  date.setMinutes(0)
  date.setHours(0)
  return date
}

export default time
